import TotalCard from 'Pages/reports/[submodules]/employees/components/TotalCard/TotalCard';
import { TotalEmployeeHistoryDetailsWrapper } from '../TotalEmployeeHistoryDetails/TotalEmployeeHistoryDetails.styled';
import PeopleIcon from '@mui/icons-material/People';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import useTranslation from 'Hooks/useTranslation';
import type { HistoryCourseEmployeesTotalsI } from 'types';
import { buildTime } from 'Pages/reports/utils/buildTime';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';

interface Props {
  totals: HistoryCourseEmployeesTotalsI;
}

const TotalCourseEmployeesDetails = ({ totals }: Props) => {
  const { t2 } = useTranslation('history_course_detail');
  const investedTime = buildTime(totals?.investedTime, t2);
  const totalTime = buildTime(totals?.totalTime, t2);

  return (
    <TotalEmployeeHistoryDetailsWrapper>
      <TotalCard
        value={totals.totalEmployees}
        label={t2('total_employees')}
        icon={<PeopleIcon />}
        description={t2('total_employees_description')}
      />
      <TotalCard
        value={totals.pendingCourses}
        label={t2('pending_courses')}
        icon={<PendingActionsIcon />}
        description={t2('pending_courses_description')}
      />
      <TotalCard
        value={totals.approvedCourses}
        label={t2('approved_courses')}
        icon={<CheckCircleIcon />}
        description={t2('approved_courses_description')}
      />
      <TotalCard
        value={investedTime}
        label={t2('invested_time')}
        icon={<AlarmOnIcon />}
        description={t2('invested_time_description')}
      />
      <TotalCard
        value={totalTime}
        label={t2('total_time')}
        icon={<QueryBuilderIcon />}
        description={t2('total_time_description')}
      />
    </TotalEmployeeHistoryDetailsWrapper>
  );
};

export default TotalCourseEmployeesDetails;
